import { render, staticRenderFns } from "./newsItem.vue?vue&type=template&id=68fd5e6d&scoped=true&"
import script from "./newsItem.vue?vue&type=script&lang=ts&"
export * from "./newsItem.vue?vue&type=script&lang=ts&"
import style0 from "./newsItem.vue?vue&type=style&index=0&id=68fd5e6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fd5e6d",
  null
  
)

export default component.exports